import { Icon } from './types';

const iconTheme: Icon = {
	sizes: {
		xs: 12,
		s: 16,
		m: 24,
		l: 32,
		xl: 48
	}
};

export default iconTheme;
